import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=7d6464f6&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6464f6')) {
      api.createRecord('7d6464f6', component.options)
    } else {
      api.reload('7d6464f6', component.options)
    }
    module.hot.accept("./spinner.vue?vue&type=template&id=7d6464f6&", function () {
      api.rerender('7d6464f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/spinner.vue"
export default component.exports